import React from 'react';
import { Breadcrumb, Grid, Row, Column, Spacing } from '@dls/web';
import { navigate } from 'gatsby';

export interface BreadcrumbItemConfig {
  label: string;
  url?: string;
}

interface PdpBreadcrumbProps {
  items: BreadcrumbItemConfig[];
}

const PdpBreadcrumb: React.FC<PdpBreadcrumbProps> = ({ items }) => (
  <Grid>
    <Row>
      <Column xs={12}>
        <Spacing top={1}>
          <Breadcrumb>
            {items.map(({ label, url }, index) => {
              const isLast = index === items.length - 1;
              return (
                <Breadcrumb.Item
                  key={index}
                  onClick={!isLast && url ? (e: React.MouseEvent) => {
                  e.preventDefault();
                  // Extract pathname+search so navigate() uses SPA routing
                  // even when url is an absolute URL (avoids full page reload)
                  try {
                    const { pathname, search } = new URL(url);
                    navigate(`${pathname}${search}`);
                  } catch {
                    navigate(url);
                  }
                } : undefined}
                  lastItem={isLast}
                >
                  {label}
                </Breadcrumb.Item>
              );
            })}
          </Breadcrumb>
        </Spacing>
      </Column>
    </Row>
  </Grid>
);

export default PdpBreadcrumb;
